import React from "react";
import { Link } from "react-router-dom";

const Homesection = () => {
  return (
    <>
      <div className="section-bar">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-12">
              <h2>What Makes WhiteHatSeo Agency Unique?</h2>
              <div className="bar"></div>
              <p>
               WhitehatSEO stands out as a modern SEO agency by combining AI-powered insights with proven, ethical SEO strategies that deliver real business results. Instead of chasing short-term rankings, we focus on building topical authority, search intent optimization, and <Link to='/services/content-marketing'>high-quality content</Link> that aligns with how search engines and users behave today. Our approach integrates technical SEO, content strategy, and data analytics to drive sustainable organic traffic and qualified leads.
                <br />
               What truly makes WhitehatSEO different is our commitment to transparency, measurable ROI, and long-term growth. We don’t rely on outdated tactics or shortcuts instead, we create scalable strategies that adapt to evolving algorithms and the rise of AI-driven search, ensuring your brand stays visible, competitive, and consistently growing.
              </p>

              <div className="row mt-4">
                <div className="col-lg-6 col-md-6 mb-4">
                  <div className="card border-0 shadow-sm">
                    <div className="d-flex align-items-center px-2 py-3">
                      <i className="fa-brands fa-google m-2"></i>
                      <h6 className="m-0">
                        Updated with latest Google algorithm changes
                      </h6>
                    </div>
                  </div>
                </div>

                <div className="col-lg-6 col-md-6 mb-4">
                  <div className="card border-0 shadow-sm">
                    <div className="d-flex align-items-center px-2 py-3">
                      <i className="fa-solid fa-chart-line m-2"></i>
                      <h6 className="m-0">
                        Aligned with current SEO trends
                      </h6>
                    </div>
                  </div>
                </div>

                <div className="col-lg-6 col-md-6 mb-4">
                  <div className="card border-0 shadow-sm">
                    <div className="d-flex align-items-center px-2 py-3">
                      <i className="fa-solid fa-location-dot m-2"></i>
                      <h6 className="m-0">
                        GEO-targeted for local & global reach
                      </h6>
                    </div>
                  </div>
                </div>

                <div className="col-lg-6 col-md-6 mb-4">
                  <div className="card border-0 shadow-sm">
                    <div className="d-flex align-items-center px-2 py-3">
                      <i className="fa-solid fa-robot m-2"></i>
                      <h6 className="m-0">
                        AI-optimized (AIO) for modern search
                      </h6>
                    </div>
                  </div>
                </div>

                <div className="col-lg-6 col-md-6 mb-4">
                  <div className="card border-0 shadow-sm">
                    <div className="d-flex align-items-center px-2 py-3">
                      <i className="fa-solid fa-users-viewfinder m-2"></i>
                      <h6 className="m-0">
                        Focused on search intent & user behavior
                      </h6>
                    </div>
                  </div>
                </div>

                <div className="col-lg-6 col-md-6 mb-4">
                  <div className="card border-0 shadow-sm">
                    <div className="d-flex align-items-center px-2 py-3">
                      <i className="fa-solid fa-award m-2"></i>
                      <h6 className="m-0">
                        EEAT-driven content & authority building
                      </h6>
                    </div>
                  </div>
                </div>

                <div className="col-lg-6 col-md-6 mb-4">
                  <div className="card border-0 shadow-sm">
                    <div className="d-flex align-items-center px-2 py-3">
                      <i className="fa-solid fa-gauge-high m-2"></i>
                      <h6 className="m-0">
                        Technical SEO for speed & performance
                      </h6>
                    </div>
                  </div>
                </div>

                <div className="col-lg-6 col-md-6 mb-4">
                  <div className="card border-0 shadow-sm">
                    <div className="d-flex align-items-center px-2 py-3">
                      <i className="fa-solid fa-arrows-rotate m-2"></i>
                      <h6 className="m-0">
                        Continuous, data-driven optimization
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-5 offset-xl-1 text-center position-relative">
              
              <img className="" src="/homeimages/seo-graph.png" alt="seo-graph" />

              <div className="rotating-img">
                <img
                  src="homeimages/rotating.png"
                  className="img14"
                  alt="animation"
                />
              </div>

             
            </div>
          </div>
        </div>
      </div>

      <div className="section-bar2 ">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="section-img position-relative">
                <img
                  src="homeimages/bulb.sectionbar2.png"
                  className="img1"
                  alt="bulb"
                ></img>
                <img
                  src="homeimages/target.sectionbar2.png"
                  className="img2"
                  alt="targetgame"
                ></img>
                {/* <img
                  src="homeimages/bigmonitor.sectionbar2.png"
                  className="img3"
                  alt="bigmonitor"
                ></img> */}
                <img
                  src="homeimages/bigpot.sectionbar2.png"
                  className="img4"
                  alt="bigpot"
                ></img>
                <img
                  src="homeimages/table.sectionbar2.png"
                  className="img5"
                  alt="table"
                ></img>
                <img
                  src="homeimages/developerman.sectionbar2.png"
                  className="img6"
                  alt="man/chair"
                ></img>
                <img
                  src="homeimages/smallmonitor.sectionbar2.png"
                  className="img7"
                  alt="smallmonitor"
                ></img>
                <img
                  src="homeimages/smallpot.sectionbar2.png"
                  className="img8"
                  alt="smallpot"
                ></img>
              </div>

              <div className="rotating1-img">
                <img
                  src="homeimages/rotating1.png"
                  className="img15"
                  alt="animation"
                />
              </div>

              {/* <div className='section-fullimg2'>
                            <img src='homeimages/section-fullimg2.png' className='img1' alt='full-img'></img>
                            </div> */}
            </div>

            <div className="col-lg-6 col-md-12">
              <h2>Why Choose WhitehatSEO Company</h2>
              <div className="bar"></div>
              <p>
               At WhitehatSEO Company, we combine AI-driven insights with ethical <Link to='/contact'>SEO practices to help</Link> you stay ahead in today’s evolving search landscape. Our strategies focus on driving organic traffic, generating high-quality leads, and delivering measurable business outcomes. With a results-driven approach, we go beyond rankings to bring real customers and long-term growth.

              </p>

              <div className="row">
                <div className="col-lg-6 col-md-6 mb-4">
                  <div className="card border-0 shadow-sm">
                    <div className="d-flex align-items-center px-2 py-3">
                      <i className="fa-solid fa-bullseye m-2"></i>
                      <h6 className="m-0">SEO focused on leads, not just traffic</h6>
                    </div>
                  </div>
                </div>

                <div className="col-lg-6 col-md-6 mb-4">
                  <div className="card border-0 shadow-sm">
                    <div className="d-flex align-items-center px-2 py-3">
                      <i className="fa-solid fa-robot m-2"></i>
                      <h6 className="m-0">Built for AI search and modern SERPs</h6>
                    </div>
                  </div>
                </div>

                <div className="col-lg-6 col-md-6 mb-4">
                  <div className="card border-0 shadow-sm">
                    <div className="d-flex align-items-center px-2 py-3">
                      <i className="fa-solid fa-route m-2"></i>
                      <h6 className="m-0">Covers full customer search journey</h6>
                    </div>
                  </div>
                </div>

                <div className="col-lg-6 col-md-6 mb-4">
                  <div className="card border-0 shadow-sm">
                    <div className="d-flex align-items-center px-2 py-3">
                      <i className="fa-solid fa-layer-group m-2"></i>
                      <h6 className="m-0">Focus on topics, not just keywords</h6>
                    </div>
                  </div>
                </div>

                <div className="col-lg-6 col-md-6 mb-4">
                  <div className="card border-0 shadow-sm">
                    <div className="d-flex align-items-center px-2 py-3">
                      <i className="fa-solid fa-chart-pie m-2"></i>
                      <h6 className="m-0">SEO + content + CRO for better conversions</h6>
                    </div>
                  </div>
                </div>

                <div className="col-lg-6 col-md-6 mb-4">
                  <div className="card border-0 shadow-sm">
                    <div className="d-flex align-items-center px-2 py-3">
                      <i className="fa-solid fa-chart-line m-2"></i>
                      <h6 className="m-0">Real-time data for continuous improvement</h6>
                    </div>
                  </div>
                </div>

                <div className="col-lg-6 col-md-6 mb-4">
                  <div className="card border-0 shadow-sm">
                    <div className="d-flex align-items-center px-2 py-3">
                      <i className="fa-solid fa-seedling m-2"></i>
                      <h6 className="m-0">Scalable strategies for long-term growth</h6>
                    </div>
                  </div>
                </div>

                <div className="col-lg-6 col-md-6 mb-4">
                  <div className="card border-0 shadow-sm">
                    <div className="d-flex align-items-center px-2 py-3">
                      <i className="fa-solid fa-magnifying-glass-dollar m-2"></i>
                      <h6 className="m-0">Transparent work with clear ROI tracking</h6>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Homesection;
